<template>
<div>
	<BaseModal :config="TransferModalLabel"
	           @ResetFields="resetFields"
	           @SaveChanges="saveChanges">
		<div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
			<form ref="refTransferForm"
			      id="TransferForm"
			      action>

				<div id="pageErrors"
				     class="alert alert-danger"
				     v-if="pageErrors.length>0">
					<p>
						<b>Please correct the following error(s):</b>
						<ul>
							<li v-for="error in pageErrors"
							    :key="error">{{ error }}</li>
						</ul>
					</p>
				</div>

				<div class="form-row">
					<div class="form-group col-md-6">
						<label class="required-label">Program</label>
						<!-- <input type="hidden" id="txtProjectName" v-model="TransferInfo.ProgramTitle" 
              class="form-control" placeholder="Program" >-->
						<div class="input-group mb-3 pl-0">
							<kendo-autocomplete id="SearchTransferProgram"
							                    class="form-control"
                                  :disabled="isCorrection || editPendingCorrection"
							                    v-model="TransferInfo.ProgramTitle"
							                    :data-source="programAutoCompleteSource"
							                    :data-text-field="'Title'"
							                    :filter="'contains'"
							                    :placeholder="'Search for Program'"
							                    @select="onProgramAutoCompleteSelect"
                                  @open="onProgramOpen"
                                  @close="onProgramClose"></kendo-autocomplete>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</div>
					</div>
					<div class="form-group col-md-6">
						<label class="required-label">Transferor</label>
						<!-- <input type="hidden" id="txtProgramName" name="Partner" v-model="TransferInfo.PartnerFullName" 
              class="form-control" placeholder="Partner" >-->
						<div class="input-group mb-3 pl-0">
							<kendo-autocomplete id="SearchSender"
							                    class="form-control"
                                  :disabled="isCorrection || editPendingCorrection"
							                    v-model="TransferInfo.SenderFullName"
							                    :data-source="partnerAutoCompleteSource"
							                    :data-text-field="'FullName'"
							                    :filter="'contains'"
							                    :placeholder="'Search for Transferor'"
							                    @select="onTransferorSelect"
                                  @open="onTransferorOpen"
                                  @close="onTransferorClose"></kendo-autocomplete>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="form-row">

            <div class="form-group col-md-6">
              <div class="form-row" style="padding:5px">Transfers can only be done to Affiliated Partners</div>
							<div class="form-row" style="padding:5px">
							  <input type="checkbox"
                  :disabled="isCorrection || editPendingCorrection"
									 class="k-checkbox form-control"
						       id="chkNonAffiliateTransfer"
						       name="NonAffiliateTransfer"
						       min="1"
						       v-model="TransferInfo.NonAffiliateTransfer"
                   @change="TransferTypeChange"
                   >
								<label class="k-checkbox-label" for="chkNonAffiliateTransfer">Check to transfer to all partners</label>
							</div>
            </div>
     
					<div class="form-group col-md-6">
						<label class="required-label">Transferee</label>
						<!-- <input type="hidden" id="txtProgramName" name="Partner" v-model="TransferInfo.PartnerFullName" 
              class="form-control" placeholder="Partner" >-->
						<div class="input-group mb-3 pl-0">
							<kendo-autocomplete id="SearchReceiver"
							                    class="form-control"
                                  :disabled="IsSenderEmpty || isCorrection || editPendingCorrection"
							                    v-model="TransferInfo.ReceiverFullName"
							                    :data-source="AffiliatedPartners"
							                    :data-text-field="'AffiliatedPartnerFullName'"
							                    :filter="'contains'"
							                    :placeholder="'Search for Transferee'"
							                    @select="onTransfereeSelect"
                                  @open="onTransfereeOpen"
                                  @close="onTransfereeClose"></kendo-autocomplete>
							<div class="input-group-append">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</div>
					</div>

				</div>

				<div class="form-row">
          <div class="form-group col-md-6">
						<label class="required-label">Unit Class</label>
            <div id="kendo-select">
               <kendo-dropdownlist v-model="TransferInfo.UnitClass"
                        :data-source="ProgramUnitClassJsonData.option"
                        :data-text-field="'UnitClass'"
                        :option-label="'Select Unit Class'"
                        @change="getTransferorAvailableUnits"
                        :data-value-field="'UnitClass'">
              </kendo-dropdownlist>
            </div>

					</div>
					<div class="form-group col-md-6">
						<label class="required-label">Unit Pool</label>

            <div id="kendo-select">
               <kendo-dropdownlist v-model="TransferInfo.UnitPool"
                        :data-source="dropdowns.UnitPool.dataSource"
                        :data-text-field="'Option'"
                        :option-label="'Select Unit Pool'"
                        @change="getTransferorAvailableUnits"
                        :data-value-field="'Option'">
              </kendo-dropdownlist>
            </div>

					</div>
				</div>
        <div class="form-row">
          <div class="form-group col-md-6">
						<label class="required-label">Unit Type</label>
            <div id="kendo-select">
               <kendo-dropdownlist v-model="TransferInfo.UnitType"
                        :data-source="dropdowns.UnitType.dataSource"
                        :data-text-field="'Option'"
                        :option-label="'Select Unit Type'"
                        @change="getTransferorAvailableUnits"
                        :data-value-field="'Option'">
              </kendo-dropdownlist>
            </div>
					</div>
					<div class="form-group col-md-6">

            	<label class="required-label">Vesting Type</label>
            <div id="kendo-select">
                <kendo-dropdownlist v-model="TransferInfo.VestingType"
                            :data-source="dropdowns.VestingType.dataSource"
                            :data-text-field="'Option'"
                            :option-label="'Select Vesting Type'"
                            :data-value-field="'Option'"
                            @change="getTransferorAvailableUnits"
                            name="Vesting Type">
                </kendo-dropdownlist>   
              </div>
					</div>
				</div>
				<div class="form-row">

					<div class="form-group col-md-6">
						<label>Transferor Available Units</label>
						<input disabled
						       v-model="AvailableUnits"
						       class="form-control">
					</div>

					<div class="form-group col-md-6">
						<label class="required-label">Units</label>
						<input type="number"
						       id="txtUnits"
						       name="Units"
						       min="1"
						       v-model="TransferInfo.Unit"
						       class="form-control"
						       placeholder="Units">
					</div>
				</div>
        <div class="form-row">
          <div class="form-group col-md-6">
						<label class="required-label">Date of Transfer</label>
						<div class="input-group">
							<kendo-datepicker
                      placeholder="Select Date"  
                      :value='TransferInfo.TransactionDate'
                      v-model='TransferInfo.TransactionDate'
                       :format="'MM/dd/yyyy'" 
                       id="dtTransactionDate"
		                   width="100%"
                        @open="_setCurrentDateifNull"
                        >
                       </kendo-datepicker>
						</div>
					</div>
        </div>

        <div class="form-row" >
        <div class="form-group col-md-12">
						<label  v-bind:class="{ 'required-label': this.isCorrection || editPendingCorrection}">Notes/Comments</label>		
            <textarea class="form-control" rows="4" cols="50" id="Notes" placeholder="Notes/Comments" v-model="TransferInfo.Note"></textarea>
				</div>
        </div>
			</form>
		</div>
	</BaseModal>
</div>
</template>

<script>
import $ from "jquery";
//import { VestingClassData  } from "@/local-data/VestingClassData.js";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseModelCorrection from "@/models/BaseModelCorrection.js"

import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelTransfer from "@/models/BaseModelTransfer.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";
import _ from "lodash";
import {mapGetters, mapActions, mapState } from 'vuex';
import TransferCorrectionConfig  from "./TransferCorrectionConfig.js";
import { isNullOrUndefined } from 'util';
import BaseModelVestingSchedule from "@/models/BaseModelVestingSchedule.js";
import VestingScheduleDatesMixin from "@/mixins/VestingScheduleDatesMixin.js"; 

export default {
  name: "TransferForm",
  props: {
    TransferInfo: {},
    TransferModalLabel: {},
    ProgramUnitClassJsonData: {},
     isCorrection:{default:false},
     editPendingCorrection:{default:false}
  },
  mixins: [apiUtil,funcUtil,VestingScheduleDatesMixin],
  watch: { 
      "TransferInfo": function(newVal) {
          this.PopulateAffiliatedPartners(newVal.SenderId,newVal.NonAffiliateTransfer);
      },
        deep: true
  }, 
  computed: {

    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),

    IsSenderEmpty(){
      return (!(this.TransferInfo.SenderId && this.TransferInfo.SenderFullName)) ? true : false
    }

  },
  data: function() {
    return {
      BaseModelProgram: BaseModelProgram,
      BaseModelVestingSchedule:BaseModelVestingSchedule,
      BaseModelCorrection:BaseModelCorrection,
      TransferCorrectionConfig:TransferCorrectionConfig,
      BaseModelPartner: BaseModelPartner,
      BaseModelUnitClass: BaseModelUnitClass,
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        UnitPool: { model: "", dataSource: [] },
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] },
      },
      programAutoCompleteSource: [],
      partnerAutoCompleteSource: [],
      AffiliatedPartners:[],
      pageErrors:[],
      AvailableUnits:0,
      bTransferorValid:true,
      bTransfereeValid:true,
      bProgramValid:true,
     
      // selectUnitPool: [
      //           { Option: 'New', Id: 1 },
      //           { Option: 'Treasury', Id: 2 },
      //       ],
      // selectUnitType:[
      //           { Option: 'Standard', Id: 1 },
      //           { Option: 'Supplemental', Id: 2 },
      //       ]
    };
  },
  methods: {
    ...mapActions("postModule",['UpdateItems','CreateItems', "CreateAllItems"]),
 
    onTransferorSelect(e){
      this.bTransferorValid=true;
      this.TransferInfo.SenderId = e.dataItem.Id;
      this.TransferInfo.SenderFullName = e.dataItem.FullName;
      this.PopulateAffiliatedPartners(this.TransferInfo.SenderId,this.TransferInfo.NonAffiliateTransfer);
      this.getTransferorAvailableUnits();
    },
    onTransferorOpen(){
      this.bTransferorValid=false;
    },
    onTransferorClose(e){
      if (!this.bTransferorValid) {
        this.TransferInfo.SenderId = null;
        this.TransferInfo.SenderFullName = null
      }
    },
    onTransfereeSelect(e){
      this.bTransfereeValid=true;
      this.TransferInfo.ReceiverId = e.dataItem.AffiliatedPartnerId;
      this.TransferInfo.ReceiverFullName = e.dataItem.AffiliatedPartnerFullName;
    },
    onTransfereeOpen(){
      this.bTransfereeValid=false;
    },
    onTransfereeClose(e){
      if (!this.bTransfereeValid) {
        this.TransferInfo.ReceiverId = null;
        this.TransferInfo.ReceiverFullName = null
      }
    },
    onProgramAutoCompleteSelect(e) {
      this.bProgramValid=true;
      this.TransferInfo.ProgramId = e.dataItem.Id;
      this.TransferInfo.ProgramTitle = e.dataItem.Title;
      this.TransferInfo.UnitClass="";

      let unitClassQuery = { filter: "ProgramId eq " + e.dataItem.Id }
      this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, unitClassQuery);

      this.getTransferorAvailableUnits();

    },
    onProgramOpen(){
      this.bProgramValid=false;
    },
    onProgramClose(){
      if (!this.bProgramValid) {
        this.TransferInfo.ProgramId = null;
        this.TransferInfo.ProgramTitle = null;
      }
    },
    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(self.BaseModelInputControl.list);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });
    }, 
    async saveChanges() {
      //code for add transfer 
      let self=this;
      this.displayErrors = true;
      //this.$validator.validate().then(result => {
        if (this.Validate()) {
          if (this.TransferModalLabel.modalAddorEdit == "add") {
            // Add Popup
            this.TransferInfo.Status = "Pending";
            this.TransferInfo.BusinessEvent = "Transfer";
            console.log(JSON.stringify(this.TransferInfo));

            //Vesting Schedule Date Changes
            let VestingScheduleResponse=self.withFilter(self.BaseModelVestingSchedule.list,{filter: "Program/Id eq " + self.TransferInfo.ProgramId +" and UnitClass eq "+"'"+self.TransferInfo.UnitClass +"'"})
            self._getVestingDates(this.TransferInfo,VestingScheduleResponse);
            
            self._updateHireDate(this.TransferInfo);

            let addFormValues = this.TransferInfo;

            //let loader = this.$loading.show();
            self._APICrudPopup("APICrudpopup");
            let ItemToCreate = { list:BaseModelTransfer, payload: addFormValues };
            this.CreateItems(ItemToCreate).then(response => {
                   $("#TransferGrid").data().kendoGrid.dataSource.read();
                  this._AlertPopup("Data Saved Successfully!","success");
              }).catch(error=>{
                this._AlertPopup("Some Error Occurred!","info");
              }).finally(()=>{
                  //loader.hide();
              })
          } else {
            // Edit Popup
            console.log(JSON.stringify(this.TransferInfo));
            let editForm = this.TransferInfo;

            //let loader;
            if(self.isCorrection)
            {
              let userResponse= await this._ConfirmationPopup("Please confirm for creating correction for this record","confirm");
              if (userResponse.value) {
                  //loader = this.$loading.show();
                  self._APICrudPopup("APICrudpopup");
                  editForm.Status = "Correction Pending"
                  let ItemToUpdate = { list:TransferCorrectionConfig, payload:editForm };
                  try {
                  let updateResponse= await self.UpdateItems(ItemToUpdate);

                      editForm.Status = "Pending";
                      editForm.BusinessEvent = "Transfer";
                      editForm.CorrectionID= editForm.Id;
                      editForm.CorrectionDate=new Date();
                      let createditem= {list: self.BaseModelCorrection,payload: editForm};
                      if (updateResponse) {
                        let createResponse=await self.CreateItems(createditem)
                      }
                      $("#TransferReportGrid").data().kendoGrid.dataSource.read();
                      this._AlertPopup("Correction created  Successfully!","success");
                  } catch(error){
                      this._AlertPopup("Some Error Occurred!","info");
                  }
                       // loader.hide()
              } 
              
            }else if(self.editPendingCorrection){
              //loader = this.$loading.show();
              self._APICrudPopup("APICrudpopup");
              let ItemToUpdate = { list:BaseModelCorrection, payload:editForm };
              self.UpdateItems(ItemToUpdate).then(response => {
              $("#CorrectionGrid").data().kendoGrid.dataSource.read();
                  //loader.hide()
                  self._AlertPopup("Correction Edited Successfully!","success"); 
                  $("#"+self.TransferModalLabel.modalIdandRef).modal("toggle"); 
              }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
              }).finally(()=>{
              })
            }
            else
            { //loader = this.$loading.show();
            self._APICrudPopup("APICrudpopup");
              let ItemToUpdate = { list:BaseModelTransfer, payload:editForm };
              self.UpdateItems(ItemToUpdate).then(response => {
              $("#TransferGrid").data().kendoGrid.dataSource.read();
                  //loader.hide()
                  self._AlertPopup("Data Saved Successfully!","success");  
              }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
              }).finally(()=>{
                //loader.hide();
              })
              
            }
                    
          // alert("Data Saved Successfully!");          
          
        }
        $("#BaseModal").modal("toggle");
        this.resetFields();
      //});
    }
    },
    resetFields: function() {
      this.pageErrors = [];
    },
    getProgramAutoCompleteData() {

      let response=this.withFilter(BaseModelProgram.list);
      this.programAutoCompleteSource = response;
    },
    getPartnerAutoCompleteData() {
      let partnerFilterQuery ={
		batchQuery:true,
        filter : function(o){
           return o.PartnerStatus !='Retired Employee' && o.PartnerStatus !='Former Employee'
        },
		limit: 5000
	}
      let response=this.withFilter(BaseModelPartner.list,partnerFilterQuery);
      this.partnerAutoCompleteSource = response;
    },
    Validate(){
      const self=this;
      self.pageErrors = [];
      let form=self.TransferInfo;
      console.log(form)
      //Form Validations
      if (!(form.ProgramTitle && form.ProgramId)) {
        self.pageErrors.push('Program is required');
      }
      if (!(form.SenderFullName && form.SenderId)) {
        self.pageErrors.push('Transferor is required');
      }
      if (!(form.ReceiverFullName && form.ReceiverId)) {
        self.pageErrors.push('Transferee is required');
      }
      if (!form.Unit || form.Unit<=0) {
        self.pageErrors.push('Units Field is Required and Should Be greater than Zero');
      }else if(!(self.isCorrection || self.editPendingCorrection) && (form.Unit > self.AvailableUnits)){
        self.pageErrors.push('Units to be Transferred should be less than Transferor Available Units');
      }
      if (!(form.SenderId==null || form.ReceiverId==null) && form.SenderId == form.ReceiverId) {
        self.pageErrors.push('Transferor and Transferee cannot be the same');
      }
      //Unit Class
      if (form.UnitClass=="") {
        self.pageErrors.push('Unit Class is required');
      } 
      //Unit Type
      if (form.UnitType=="") {
        self.pageErrors.push('Unit Type is required');
      }
      //Vesting Type
      if (isNullOrUndefined(form.VestingType) || form.VestingType=="") {
        self.pageErrors.push('Vesting Type is required');
      }
      //Unit Pool
      if (form.UnitPool=="") {
        self.pageErrors.push('Unit Pool is required');
      }
      if (form.TransactionDate=="" || form.TransactionDate==null) {
        self.pageErrors.push('Date of Transfer is required');
      }
      if((form.Note==""||form.Note==null)&& (self.isCorrection || self.editPendingCorrection))
      {
       self.pageErrors.push('Note/Comments is required');
      }
      if (self._validateSpecialCharacter(form.Note,"multiline")) {
        self.pageErrors.push(`Notes/Comments cannot have ${this.MultiLineSpecialChars}  Characters`);
      }

      return self.pageErrors.length>0 ? false:true
    },
    getTransferorAvailableUnits(){

      this.calculateAvailableUnits(this.TransferInfo);

    },
    calculateAvailableUnits(transferInfo){
      //Initialize to Zero Everytime
      let self = this;
      if (self.isCorrection || self.editPendingCorrection) {
        self.AvailableUnits="Not Applicable";
        return;
      }
      self.AvailableUnits=0;
      let form=transferInfo
      if (form.SenderFullName && form.ProgramTitle && form.UnitClass!="" && form.UnitType!="" && form.UnitPool!=""&& form.VestingType!="") {
        //alert("Started Calculations")
        let response=this.withFilter(BaseModelUnitRunningTotal.list, {
          filter: `ProgramId eq ${form.ProgramId} and PartnerId eq ${form.SenderId}`
        });
        
        //console.log(response) 
        let filteredResponse=_.filter(response, function(item){
            return item.UnitClass==form.UnitClass && item.UnitType==form.UnitType && item.UnitPool==form.UnitPool && item.VestingType==form.VestingType
        })
          //console.log(filteredResponse)
        if (filteredResponse[0]) {
            self.AvailableUnits=filteredResponse[0].Unit;
            //console.log(self.AvailableUnits)
            //console.log(this.TransferInfo)
          }
      }
      
    },
    PopulateAffiliatedPartners(PartnerId,NonAffiliateTransfer){
      const self=this;
      if (PartnerId) {
        let query = { filter: "PartnerId eq " + PartnerId }
        let AffiliatedPartnerList=this.withFilter(BaseModelPartnerAffiliation.list, query)
        let AllPartnerList=this.withFilter(BaseModelPartner.list)
        if (NonAffiliateTransfer) {
          //Get Non Affiliated Partners AllPartners-AffiliatedPartners
          //self.AffiliatedPartners=
          let NonAffilatedPartnerList = AllPartnerList.filter(function(item) {
            return (AffiliatedPartnerList.filter(e => e.AffiliatedPartnerId == item.Id).length > 0)?false:true
          });  
          //Transform the Data for Binding to DataSource 
          let NonAffiliatedPartners=[];
          NonAffilatedPartnerList.forEach(element => {
              NonAffiliatedPartners.push({"AffiliatedPartnerId":element.Id,"AffiliatedPartnerFullName":element.FullName}) 
          });
        self.AffiliatedPartners=NonAffiliatedPartners;

        } else {
          self.AffiliatedPartners=AffiliatedPartnerList;
        }
        if (self.TransferInfo.ReceiverId) {
          //Validate Against the Affilaited Partner List
              let bExists=self.AffiliatedPartners.some(function (obj) {
                return obj.AffiliatedPartnerId == self.TransferInfo.ReceiverId;
              });
              if (!bExists) {
                  self.TransferInfo.ReceiverId=null;
                  self.TransferInfo.ReceiverFullName=null;
              }
        }
      }
      else{
        self.AffiliatedPartners=[];
        self.TransferInfo.ReceiverId=null;
        self.TransferInfo.ReceiverFullName=null;
      }
    },
    TransferTypeChange(e){
      //console.log(this.TransferInfo.NonAffiliateTransfer)
      this.PopulateAffiliatedPartners(this.TransferInfo.SenderId,this.TransferInfo.NonAffiliateTransfer);
    }
   
  },

  mounted() {
    this.getInputControls();
    const self=this;
    // alert(JSON.stringify(this.ProgramInfoFormConfig));
    this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, '')
    this.ProgramUnitClassJsonData.unitType = [
            { Option: 'Standard', Id: 1 },
            { Option: 'Supplemental', Id: 2 },
        ]
    this.ProgramUnitClassJsonData.unitPool =    [
          { Option: 'New', Id: 1 },
          { Option: 'Treasury', Id: 2 },
      ]
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    this.getProgramAutoCompleteData();
    this.getPartnerAutoCompleteData();
    this.PopulateAffiliatedPartners(this.TransferInfo.SenderId,this.TransferInfo.NonAffiliateTransfer);

    //For Displaying List on Focus
    self.ShowAutoCompleteListOnFocus("SearchReceiver");
    self.ShowAutoCompleteListOnFocus("SearchTransferProgram");
    self.ShowAutoCompleteListOnFocus("SearchSender");
  },
  components: {
    BaseModal
  }
};
</script>


<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}
</style>